import { AppLocale } from '@type/app-locale';

export const DEFAULT_APP_LOCALE: AppLocale = 'en';
